var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDownBlue = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#svg_0a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0070CC",
    d: "M16.0002 22.6501c-.3797 0-.7172-.1266-.9703-.3797l-8.1-8.1c-.5485-.5063-.5485-1.3922 0-1.8985.5062-.5484 1.3921-.5484 1.8985 0l7.1718 7.1298 7.1297-7.1298c.5062-.5484 1.3921-.5484 1.8985 0 .5484.5063.5484 1.3922 0 1.8985l-8.1 8.1c-.2532.2531-.5907.3797-.9282.3797"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "svg_0a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowDownBlue);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-down-blue.cd8a8a7fd1667048b22f5f132c75e9e5.svg";